import jwt_decode from 'jwt-decode';

export const BACKUP_KEY = 'impersonation_backup';

export const isImpersonating = () => {
    try {
        return !!localStorage.getItem(BACKUP_KEY) && !!jwt_decode(localStorage.getItem('access_token'))?.impersonated_by;
    } catch (e) {
        return false;
    }
};

export const getImpersonationInfo = () => {
    try {
        const decoded = jwt_decode(localStorage.getItem('access_token'));
        if (!decoded?.impersonated_by) {
            return null;
        }
        return {
            target: JSON.parse(localStorage.getItem('user')),
            actor: decoded.impersonated_by,
            expiresAt: new Date(decoded.exp * 1000),
        };
    } catch (e) {
        return null;
    }
};

export const saveBackup = () => {
    localStorage.setItem(BACKUP_KEY, JSON.stringify({
        access_token: localStorage.getItem('access_token'),
        refresh_token: localStorage.getItem('refresh_token'),
        user: localStorage.getItem('user'),
        companies: localStorage.getItem('companies'),
        companyId: localStorage.getItem('companyId'),
        allotmentId: localStorage.getItem('allotmentId'),
        userAllotmentId: localStorage.getItem('userAllotmentId'),
    }));
};

export const restoreBackup = () => {
    try {
        const backup = localStorage.getItem(BACKUP_KEY);
        if (!backup) {
            return false;
        }
        const data = JSON.parse(backup);
        Object.keys(data).forEach((key) => {
            if (data[key] === null) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(key, data[key]);
            }
        });
        localStorage.removeItem(BACKUP_KEY);
        return true;
    } catch (e) {
        return false;
    }
};

export const clearBackup = () => {
    localStorage.removeItem(BACKUP_KEY);
};

export const clearCustomScope = () => {
    sessionStorage.removeItem('access_token_custom');
    sessionStorage.removeItem('refresh_token_custom');
    sessionStorage.removeItem('allotmentIdScope');
};
